






































import Vue from 'vue';
import { mapState } from 'vuex';
import { EOfferType, EOfferTypePillText } from '../enums';
import { IOffersItem } from '../types';
import CarOffer from './dumb/CarOffer.vue';

export default Vue.extend({
	props: ['onCollection'],
	components: {
		CarOffer
	},
	computed: {
		...mapState({
			app(): any { return this.$store.state.app },
			vehicle(): any { return this.$store.state.vehicle }
		}), 
		EOfferTypePillTextVehiclePrice(){
			return EOfferTypePillText.VehiclePrice;
		},
		EOfferTypePillTextFinanceText(){
			return EOfferTypePillText.FinanceText;
		},
		EOfferTypePillTextVehicleText(){
			return EOfferTypePillText.VehicleText;
		},
		enabledOffers(): Array<EOfferType> {
			const all = [
				EOfferType.VehiclePrice,
				EOfferType.VehicleText,
				EOfferType.FinanceText
			];
			switch (this.app.step){
				case 0: {
					return all;
				}
				default: {
					if (this.app.paymentMethod == 'cash'){
						return [
							EOfferType.VehiclePrice,
							EOfferType.VehicleText
						];
					}
					else {
						return [
							EOfferType.VehiclePrice,
							EOfferType.VehicleText, 
							EOfferType.FinanceText
						];
					}
				}
			}
		},
		offers(): Array<IOffersItem> {
			return this.vehicle.offers;
		},
		driveawayOffer(): IOffersItem | null {
			if (!this.isOfferTypeEnabled(EOfferType.VehiclePrice)) return null;
			const arr = this.offers.filter((o: IOffersItem) => o.offerType == EOfferType.VehiclePrice);
			return arr.length ? arr[0] : null;
		},
		financeOffer(): IOffersItem | null {
			if (!this.isOfferTypeEnabled(EOfferType.FinanceText)) return null;
			const arr = this.offers.filter((o: IOffersItem) => o.offerType == EOfferType.FinanceText);
			return arr.length ? arr[0] : null;
		},
		textOffer(): IOffersItem | null {
			if (!this.isOfferTypeEnabled(EOfferType.VehicleText)) return null;
			const arr = this.offers.filter((o: IOffersItem) => o.offerType == EOfferType.VehicleText);
			return arr.length ? arr[0] : null;
		},
		hasOffer(): boolean {
			return !!this.offers.length;
		},
	}, 
	methods: {
		isOfferTypeEnabled(f: EOfferType): boolean {
			return this.enabledOffers.includes(f);
		}
	}
})
